import { TimelineMax, TweenMax } from 'gsap/TweenMax';
import selectors from '@/scripts/animation/animation-selectors';

function getAssets(section, subtitle) {
  return {
    number: section.querySelector(`${subtitle} ${selectors.number}`),
    line: section.querySelector(`${subtitle} ${selectors.line}`),
    text: section.querySelector(`${subtitle} ${selectors.text}`),
  };
}

export default {
  trigger: selectors.eyebrow,
  set() {
    const { number, text, line } = getAssets(this.section, selectors.eyebrow);
    return TweenMax.set([number, text, line], { autoAlpha: 0 });
  },

  animate() {
    const { number, text, line } = getAssets(this.section, selectors.eyebrow);
    const tl = new TimelineMax();
    return tl
      .fromTo(number || 'undefined', selectors.duration, { autoAlpha: 0, x: 0 }, { autoAlpha: 1, clearProps: 'all' }, selectors.delay.stage_0)
      .fromTo(line, selectors.duration, { scaleX: 0, autoAlpha: 1, x: 0 }, { scaleX: 1, clearProps: 'all' }, selectors.delay.stage_1)
      .fromTo(text, selectors.duration, { x: -20, autoAlpha: 0 }, { x: 0, autoAlpha: 1, clearProps: 'all' }, selectors.delay.stage_2);
  },
};



// WEBPACK FOOTER //
// ./scripts/animation/elements/eyebrow.js